import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export interface KitTier {
  _id?: string;
  key: "basic" | "advanced" | "premium";
  label: string;
  description?: string;
  price: number;
  currency: string;
  enabled: boolean;
  order?: number;
}

interface TierListResponse { success?: boolean; data?: KitTier[]; }
interface TierOneResponse { success?: boolean; message?: string; data?: KitTier; }

export const getKitTiers = async (): Promise<KitTier[]> => {
  const res = await apiClient.get<TierListResponse>(ENDPOINTS.ADMIN.KIT_TIERS);
  return res.data?.data || [];
};

export const updateKitTier = async (
  key: string,
  payload: Partial<Pick<KitTier, "label" | "description" | "price" | "currency" | "enabled">>
): Promise<KitTier | null> => {
  const res = await apiClient.patch<TierOneResponse>(ENDPOINTS.ADMIN.KIT_TIER_UPDATE(key), payload);
  return res.data?.data || null;
};
